<template>
    <div>
        <div class="bg">
            <div class="container">
                <el-carousel height="454px">
                    <el-carousel-item v-for="item in bannerList1" :key="item.id">
                        <img :src="item.image" @click="imgBnt(item.url)" class="banner-img" alt="" />
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>
<script>
import { banners_pc } from "@/api/index.js";
export default {
    props: {
        url: {
            type: Array
        }
    },
    data() {
        return {
            bannerList1:[],

        };
    },
    created() {
        this.getNew();
    },
    methods: {
        getNew() {
            console.log(this.url[0].url);
            switch (this.url[0].url) {
                case "/new":
                    banners_pc({ status: "NewProduct1" }).then(res => {
                        this.bannerList1 = res.data.lists
                        console.log(this.bannerList);

                    });

                    break;
                    case "/special":
                    banners_pc({ status: "Special1" }).then(res => {
                        this.bannerList1 = res.data.lists
                        console.log(res);

                    });

                    break;
                    case "/seckill":
                    banners_pc({ status: "Seckill1" }).then(res => {
                        this.bannerList1 = res.data.lists
                        console.log(res);

                    });

                    break;
                    case "/brand":
                         banners_pc({ status: "Brand" }).then(res => {
                        this.bannerList1 = res.data.lists
                        console.log(res);

                    });
                    break;

                default:
                    break;
            }
            // if(this.url[0].url == '/new'){

            // }
        },
        imgBnt(url){
         if(url == ''){
            return
        }
        window.open(url);
        }
    }
};
</script>
<style>
.bg {
    width: 100%;
    height: 500px;
    background: url("../images/bg2.png") 100% 100%;
    padding-top: 100px;
    margin-bottom: 80px;
}
.banner-img {
    width: 100%;
    height: 100%;
    cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/banner.vue